import React, { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    naver: any;
  }
}

const NaverMap = ({
  nameAddress,
  latDefault,
  lngDefault,
  handleSetLatLngClick,
}: {
  nameAddress?: string;
  latDefault?: any;
  lngDefault?: any;
  handleSetLatLngClick?: any;
}) => {
  const [map, setMap] = useState(null);
  const [markerOld, setMarker] = useState(null);
  const [isMarkerDefault, setIsMarkerDefault] = useState<boolean>(false);
  const [markers, setMarkers] = useState<any>([]);
  const [selectedCoords, setSelectedCoords] = useState({
    lat: null,
    lng: null,
  });

  useEffect(() => {
    if(latDefault || lngDefault) {
      setIsMarkerDefault(true);
    }

    const loadScript = () => {
      return new Promise((resolve, reject) => {
        if (document.getElementById("naver-map-script")) {
          resolve("Script already loaded");
          return;
        }

        const script = document.createElement("script");
        script.id = "naver-map-script";
        script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${process.env.REACT_APP_API_CLIENT_ID}`;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const initializeMap = () => {
      let mapCenter = new window.naver.maps.LatLng(37.5665, 126.9780);
      if(latDefault || lngDefault) {
          mapCenter = new window.naver.maps.LatLng(latDefault, lngDefault); // Seoul coordinates
      }

      // Khởi tạo bản đồ
      const newMap = new window.naver.maps.Map("map", {
        center: mapCenter,
        zoom: 10,
      });

      if(latDefault || lngDefault) {
        mapCenter = new window.naver.maps.LatLng(latDefault, lngDefault);
        const marker = new window.naver.maps.Marker({
          position: mapCenter,
          map: newMap,
          title: nameAddress,
        });

        window.naver.maps.Event.addListener(marker, "click", () => {
          const googleMapsLink = `https://map.naver.com/v5/search/${mapCenter.lat()},${mapCenter.lng()}`;
          window.open(googleMapsLink, "_blank");
        });
      }

      setMap(newMap);
      
      window.naver.maps.Event.addListener(newMap, "click", (e: any) => {
        const lat = e.coord.lat();
        const lng = e.coord.lng();

        handleSetLatLngClick(lat, lng);
        setSelectedCoords({ lat, lng });

        markers.forEach((marker: any) => marker.setMap(null));
        setMarkers([]);

        // if (markerOld) {
        //     marker.setMap(new window.naver.maps.Marker({
        //         position: mapCenter,
        //         map: newMap,
        //         title: nameAddress,
        //     }));
        // }

        const newMarker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(lat, lng),
          map: newMap,
          title: `Selected Location: (${lat}, ${lng})`,
        });
        setMarker(newMarker);

      });
    };

    loadScript()
      .then((message) => {
        if (window.naver) {
          initializeMap();
        } else {
          console.error("Naver Maps script failed to load.");
        }
      })
      .catch((err) => console.error("Failed to load Naver Maps script:", err));
  }, [latDefault, lngDefault]);

  return <div id="map" style={{ width: "100%", height: "350px" }} />;
};

export default NaverMap;
